import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-es-info',
  templateUrl: './es-info.component.html',
  styleUrls: ['./es-info.component.scss']
})
export class EsInfoComponent implements OnInit {
  @Input() data: string[] = [];

  constructor() { }

  ngOnInit(): void {
  }

}
